var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"p2-style",attrs:{"id":"portfolio-table"}},[_c('PortfolioTableHeader'),(_vm.importingBulkData)?_c('div',{staticClass:"body"}):_c('VirtualScroll',{staticClass:"body",attrs:{"securities":_vm.sortedSecurities}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }